import { Access, AccessComponentEnum, AccessLevelEnum } from 'graphql-common';
import { checkUserAccessByComponent } from '@lib/utils/accesses';
import { APP_URLS } from 'constants/urls';

function isAccessClosed(accesses: Access[], component: AccessComponentEnum) {
  return (
    checkUserAccessByComponent(accesses, component) !==
    AccessLevelEnum.LimitedRead
  );
}

export default function getHomePageUrl(accesses: Access[]) {
  if (isAccessClosed(accesses, AccessComponentEnum.HomePageManagement)) {
    return APP_URLS.dashboard.home.getPathWithQuery();
  }
  if (isAccessClosed(accesses, AccessComponentEnum.TasksManagement)) {
    return APP_URLS.dashboard.overview.getPathWithQuery();
  }
  if (isAccessClosed(accesses, AccessComponentEnum.FormCategoriesManagement)) {
    return APP_URLS.dashboard.formTemplates.categories.getPathWithQuery();
  }
  if (isAccessClosed(accesses, AccessComponentEnum.InterventionsManagement)) {
    return APP_URLS.dashboard.interventions.index.getPathWithQuery();
  }
  if (
    isAccessClosed(
      accesses,
      AccessComponentEnum.InterventionCategoriesManagement,
    )
  ) {
    return APP_URLS.dashboard.interventions.categories.getPathWithQuery();
  }
  if (isAccessClosed(accesses, AccessComponentEnum.SitesManagement)) {
    return APP_URLS.dashboard.sites.index.getPathWithQuery();
  }
  if (isAccessClosed(accesses, AccessComponentEnum.SitesManagement)) {
    return APP_URLS.dashboard.sites.index.getPathWithQuery();
  }
  if (isAccessClosed(accesses, AccessComponentEnum.UsersManagement)) {
    return APP_URLS.dashboard.users.index.getPathWithQuery();
  }
  if (isAccessClosed(accesses, AccessComponentEnum.AssetsManagement)) {
    return APP_URLS.dashboard.assets.index.getPathWithQuery();
  }
  if (isAccessClosed(accesses, AccessComponentEnum.AssetsCounterReading)) {
    return APP_URLS.dashboard.assets.counters.getPathWithQuery();
  }
  if (isAccessClosed(accesses, AccessComponentEnum.AssetCategoriesManagement)) {
    return APP_URLS.dashboard.assets.categories.getPathWithQuery();
  }
  return APP_URLS.dashboard.profile.path;
}
